export default class DeclineReasonSerializer {
  static serialize(data) {
    return {
      declineReasonID: data.declineReasonID,
      declineReasonName: data.declineReasonName
    };
  }

  static deSerialize(data) {
    return {
      declineReasonID: data.declineReasonID,
      declineReasonName: data.declineReasonName
    };
  }
}